<template>
    <div>Financiamiento</div>
</template>

<script>

export default {
    name: "Financiamiento",
    components: {
    },
    data() {
        return {

        };
    },
    props: {
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped></style>
